import { render, staticRenderFns } from "./PlayerPendings.vue?vue&type=template&id=a2bf379c&"
import script from "./PlayerPendings.vue?vue&type=script&lang=js&"
export * from "./PlayerPendings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports